import { createContext } from 'react';

import {
  SoftwareImportResult,
  SoftwareImportStatus,
  SoftwareImportSummary,
} from '@totem/components/devices/software-import/types';

interface Context {
  status: SoftwareImportStatus;
  fileName: string;
  error: string;
  result: SoftwareImportResult | null;
  summary: SoftwareImportSummary | null;
  deleting: boolean;
  onImport: (file: File) => void;
  onReset: () => void;
  onDeleteImported: () => void;
}

export default createContext<Context>({
  status: 'idle',
  fileName: '',
  error: '',
  result: null,
  summary: null,
  deleting: false,
  onImport: () => {},
  onReset: () => {},
  onDeleteImported: () => {},
});
